import { render, staticRenderFns } from "./FlaggedUsersToolbar.vue?vue&type=template&id=7c784888&"
import script from "./FlaggedUsersToolbar.vue?vue&type=script&lang=js&"
export * from "./FlaggedUsersToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports